<footer class="text-center py-3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 text-center text-md-left "><p>© {{ 'HOME.copy_right' | translate }}.</p></div>
            <div class="col-md-3 text-center text-md-left card-logo ">
                <img src="assets/img/visa-master.png"/>
            </div>
            <div class="col-md-5 text-center ft-link text-md-right">
                <a [routerLink]="['/login']" *ngIf="!isloggedin">{{ 'HOME.login' | translate }}</a>
                <a [routerLink]="['/register']" *ngIf="!isloggedin">{{ 'HOME.Register' | translate }}</a>
                <a [routerLink]="['/cart']">{{ 'HOME.cart' | translate }}</a>
                <a [routerLink]="['/my-account']" *ngIf="isloggedin">{{ 'HOME.My_Account' | translate }}</a>
                <a href="https://www.sajway.com/blog/" target="_blank" >{{ 'HOME.blog' | translate }}</a>
                <a [routerLink]="['/page/privacy-policy']">{{ 'HOME.Privacy_Policy' | translate }}</a>
                <a [routerLink]="['/page/terms-and-conditions']">{{ 'HOME.Terms_Conditions' | translate }}</a>
            </div>   
        </div>
    </div>
</footer>